import React from 'react';
export default function SkipTimer({ sec }) {
  return <span className="skip-countdown" aria-hidden="true">{sec}<small>s</small></span>;
}
